import $ from 'jquery'

$(document).ready(dhsv_vc_research_seminars_list())

function dhsv_vc_research_seminars_list() {
  $('.seminars-toggle-js').on('click', function() {
    $(this).toggleClass('active')
    $(this)
      .parents()
      .next('.seminars-lists-js')
      .slideToggle()
  })
}
